import { createContext } from "react";

import { AmplitudeVariantValue, Emptyable } from "@simplyk/common";

interface AmplitudeExperienceContextProps {
  isNewPermissionExperience: {
    isLoading: boolean;
    isActive: boolean;
    value?: Emptyable<AmplitudeVariantValue>;
  };
}

export const AmplitudeExperienceContext = createContext<AmplitudeExperienceContextProps>({
  isNewPermissionExperience: {
    isLoading: false,
    isActive: false,
    value: null,
  },
});
